export default __webpack_public_path__ + "static/media/home-bg.2e954c4d.png";